import { path, equals } from 'ramda'
import { useState, useEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Dialog, Box, Text, Button, TextLinkButton, Inline } from '@machobear/design-system'
import Logo from '@/assets/liv-logo.svg'

import Agreement from './agreement'

export const AgreementModal = ({ visible, closeModal }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const mismatched = useSelector(path(['agreement', 'mismatched']))
  const [agreementId, setAgreementId] = useState()
  const [pendingAgreements, setPendingAgreements] = useState()

  useEffect(() => {
    if (Object.keys(mismatched).length < 1) {
      closeModal()
    } else {
      setPendingAgreements(mismatched)
    }
  }, [closeModal, mismatched])

  const onClose = () => {
    setAgreementId(null)
    dispatch.agreement.update({ currentAgreement: null })
  }

  const handleAgreeClick = () => {
    dispatch.agreement.agreeToAgreements()
    closeModal()
  }

  const getLink = agreement => {
    return (
      <TextLinkButton
        theme="text"
        onClick={() => viewAgreement(agreement.txt_id)}
        key={agreement.txt_id}
      >
        {agreement.title}
      </TextLinkButton>
    )
  }

  const viewAgreement = id => {
    dispatch.agreement.loadAgreement(id)
    setAgreementId(id)
  }

  const mismatchKeys = Object.keys(pendingAgreements || {})
  const mismatchLength = mismatchKeys.length

  const getTitleLinks = () => {
    const agreements = mismatchKeys.map(key => pendingAgreements[key])

    return agreements.map((agreement, index) => (
      <span key={agreement.txt_id}>
        {agreements.length > 1 && index === agreements.length - 1 && ' and '}
        {getLink(agreement)}
        {index < agreements.length - 1 && ', '}
      </span>
    ))
  }

  const getTitles = () => {
    return mismatchKeys
      .map(key => pendingAgreements[key].title)
      .join(', ')
      .replace(/,(?=[^,]*$)/, ' and')
  }

  // Terms & Conditions needs to use have, not has
  const getTenseOfHave = () =>
    mismatchLength > 1 || equals(mismatchKeys, ['terms_conditions']) ? 2 : 1
  const count = getTenseOfHave()
  const terms = getTitles()
  const Links = () => <span>{getTitleLinks()}</span>
  return (
    <Dialog id="agreement-modal" open={visible} width="small" hideXButton={true}>
      <Box>
        {agreementId ? (
          <Agreement agreementId={agreementId} onClose={onClose} onChange={viewAgreement} />
        ) : (
          <Box
            gap="gutter"
            display="flex"
            alignItems="center"
            flexDirection="column"
            overflow="auto"
          >
            <img src={Logo} alt="Liv Logo" height="72px" width="auto" />
            {pendingAgreements && (
              <>
                <Box>
                  <Text weight="strong" size="large" data={{ testid: 'agreement-modal-title' }}>
                    <Trans
                      i18nKey="b.agreement_modal.view.accept_and_continue.title"
                      values={{ terms }}
                      count={count}
                    >
                      Our <span>{{ terms }}</span> have changed
                    </Trans>
                  </Text>
                </Box>
                <Box>
                  <Text>
                    <Trans
                      i18nKey="b.agreement_modal.view.accept_and_continue.description"
                      components={{ terms: <Links /> }}
                    >
                      We have updated our <terms />. Please review these updates and let us know if
                      you consent as part of your ongoing use of liv.rent.
                    </Trans>
                  </Text>
                </Box>
                <Inline>
                  <Button theme="primary" onClick={handleAgreeClick}>
                    {t('b.agreement_modal.view.accept_and_continue.button', 'Accept and Continue')}
                  </Button>
                </Inline>
              </>
            )}
          </Box>
        )}
      </Box>
    </Dialog>
  )
}
